import React, { useEffect, useRef } from 'react';
import './Pad.scss';
import { Button } from '../Button/Button';
import { FaDeleteLeft } from 'react-icons/fa6';

interface PadProps {
    onNumberClick: (number: string) => void;
    onDelete: () => void;
    listenToKeyboard?: boolean;
}

export const Pad: React.FC<PadProps> = ({ onNumberClick, onDelete, listenToKeyboard = false }) => {
    const numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    const lastKeyPressTime = useRef<number>(0);
    const lastKeyPressed = useRef<string>('');
    const debounceTime = 100; // ms

    // Fonction sécurisée pour les clics sur les boutons
    const handleButtonClick = (number: string) => {
        onNumberClick(number);
    };

    // Fonction sécurisée pour la suppression
    const handleDeleteClick = () => {
        onDelete();
    };

    useEffect(() => {
        if (!listenToKeyboard) return;

        const handleKeyDown = (e: KeyboardEvent) => {
            const now = Date.now();
            const currentKey = `${e.key}-${e.timeStamp}`;

            // Vérifier si c'est le même événement ou un événement trop rapproché
            if (now - lastKeyPressTime.current < debounceTime || currentKey === lastKeyPressed.current) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }

            lastKeyPressTime.current = now;
            lastKeyPressed.current = currentKey;

            if (numbers.includes(e.key)) {
                e.preventDefault();
                e.stopPropagation();
                onNumberClick(e.key);
            } else if (e.key === 'Backspace') {
                e.preventDefault();
                e.stopPropagation();
                onDelete();
            }
        };

        window.addEventListener('keydown', handleKeyDown, { capture: true });

        return () => {
            window.removeEventListener('keydown', handleKeyDown, { capture: true });
        };
    }, [onNumberClick, onDelete, listenToKeyboard, numbers]);

    return (
        <div className="pad">
            <div className="pad-grid">
                {numbers.map((number) => (
                    <Button key={number} label={number} variant="light" callback={() => handleButtonClick(number)} className="pad-button" />
                ))}
                <Button icon={<FaDeleteLeft />} iconAfter variant="light" callback={handleDeleteClick} className="pad-button delete" />
            </div>
        </div>
    );
};
